<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 class="font-size--24">신용인증이 완료되었어요!</h1>
      <h1 class="font-size--24">아쉽게도 진행이 어려워요</h1>
      <v-footer fixed>
        <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
          <BasicButton class="button next-button" depressed height="48" :to="{ path: '/earlypay' }">
            확인
          </BasicButton>
        </v-layout>
      </v-footer>
      <!-- 하단 영역 -->
    </section>
  </div>
</template>
<script>
export default {
  created() {
    _meta({
      titles: ['신용평가실패'],
    })
  },
}
</script>
<style lang="scss" scoped>
#section__failure {
  .v-card {
    background-color: #fff6f1;
    border-radius: 8px;
  }
}
</style>
